/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Insert_ButtonInputs */



/**
* | output |
* | --- |
* | "Insert Tag" |
*
* @param {Tags_Manager_Insert_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_insert_button = /** @type {((inputs?: Tags_Manager_Insert_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Insert_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer le tag")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить тег")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar etiqueta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir etiqueta")
	return /** @type {LocalizedString} */ ("Insert Tag")
});